// src/data/subjects.js
export const SUBJECTS = [
  "Afrikaans Eerste Additionele Taal",
  "Afrikaans Huistaal",
  "Afrikaans Tweede Addisionele Taal",
  "Agricultural Management Practices",
  "Agricultural Sciences",
  "Agricultural Technology",
  "Business Studies",
  "Civil Technology",
  "Computer Application Technology",
  "Consumer Studies",
  "Dance Studies",
  "Design",
  "Dramatic Arts",
  "Economics",
  "Electrical Technology",
  "Engineering Graphics and Design",
  "English First Additional Language",
  "English Home Language",
  "English Second Additional Language",
  "Geography",
  "History",
  "Hospitality Studies",
  "Information Technology",
  "isiNdebele First Additional Language",
  "isiNdebele Home Language",
  "isiNdebele Second Additional Language",
  "IsiXhosa First Additional Language",
  "IsiXhosa Home Language",
  "IsiXhosa Second Additional Language",
  "IsiZulu First Additional Language",
  "IsiZulu Home Language",
  "IsiZulu Second Additional Language",
  "Life Orientation",
  "Life Sciences",
  "Mathematical Literacy",
  "Mathematics",
  "Mechanical Technology",
  "Music",
  "Physical Sciences",
  "Religion Studies",
  "Sepedi First Additional Language",
  "Sepedi Home Language",
  "Sepedi Second Additional Language",
  "Sesotho First Additional Language",
  "Sesotho Home Language",
  "Sesotho Second Additional Language",
  "Setswana First Additional Language",
  "Setswana Home Language",
  "Setswana Second Additional Language",
  "Siswati First Additional Language",
  "Siswati Home Language",
  "Siswati Second Additional Language",
  "Technical Mathematics",
  "Technical Sciences",
  "Tourism",
  "Tshivenda First Additional Language",
  "Tshivenda Home Language",
  "Tshivenda Second Additional Language",
  "Visual Arts",
  "Xitsonga First Additional Language",
  "Xitsonga Home Language",
  "Xitsonga Second Additional Language"
];